import {
  GRAPH_INITIALIZATION,
  getStarted,
  getSucceeded,
  UPDATE_BIG_GRAPH,
  getEnded,
  ON_CHANGE_ANALYZEFORM,
  ON_CHANGE_FACTOR_ANALYZEFORM,
  ANALYZEPAGE_DATE_CHANGED,
  RESET_ANALYZE_PAGE,
  getFailed,
  ON_GRAPH_EXPORT,
  GRAPH_INITIALIZATION_FAILED,
} from "../actions/constant";
import _ from "lodash";
//import dashboard from "material-ui/svg-icons/action/dashboard";
import moment from "moment";
import i18n from "../i18n";

const chartLablesMaker = (period, min) => {
  min = moment(min).startOf("day") || moment().startOf("day");
  switch (period) {
    case "1W":
      let result = {
        data: [],
        min: min,
        max: moment(min).add(1, "week").endOf("day"),
      };
      for (let i = 2; i < 7; i = i + 2) {
        result.data.push(moment(min).add(i, "days"));
      }
      return result;
    case "2W":
      result = {
        data: [],
        min: min,
        max: moment(min).add(2, "weeks").endOf("day"),
      };
      for (let i = 3; i < 14; i = i + 3) {
        result.data.push(moment(min).add(i, "days"));
      }
      return result;
    case "1M":
      result = {
        data: [],
        min: min,
        max: moment(min).add(28, "days").endOf("day"),
      };
      for (let i = 7; i < 28; i = i + 7) {
        result.data.push(moment(min).add(i, "days"));
      }
      return result;
    case "3M":
      result = {
        data: [],
        min: min,
        max: moment(min).add(3, "months").endOf("day"),
      };
      for (let i = 15; i < 90; i = i + 15) {
        result.data.push(moment(min).add(i, "days"));
      }
      return result;
    case "6M":
      result = {
        data: [],
        min: min,
        max: moment(min).add(6, "months").endOf("day"),
      };
      for (let i = 1; i < 6; i++) {
        result.data.push(moment(min).add(i, "months"));
      }
      return result;
    case "1Y":
      result = {
        data: [],
        min: min,
        max: moment(min).add(1, "years").endOf("day"),
      };
      for (let i = 3; i < 12; i = i + 3) {
        var newDate = moment(min).add(i, "months");
        result.data.push(newDate);
      }
      return result;
    case "2Y":
      result = {
        data: [],
        min: min,
        max: moment(min).add(2, "years").endOf("day"),
      };
      for (let i = 6; i < 24; i = i + 6) {
        var newDate = moment(min).add(i, "months");
        result.data.push(newDate);
      }
      return result;
    case "5Y":
      result = {
        data: [],
        min: min,
        max: moment(min).add(5, "years").endOf("day"),
      };
      for (let i = 1; i < 5; i++) {
        var newDate = moment(min).add(i, "years");
        result.data.push(newDate);
      }

      return result;
    default:
      break;
  }
};

const initialState = {
  symptomOfAllUser: [],
  isLoading: true,
  users: [],
  selectedUser: {},
  selectedSymptom: {},
  factors: [],
  OptionForm: {},
  symptoms: [],
  from: "",
  to: "",
  pointAlert: false,
  nutrients: [],
  disabled: {
    factor: true,
    nutrients: true,
    start: true,
    end: true,
    time: true,
    plotBtn: true,
  },
  counterState: 0,
  searchMode: true,
  graphSymptoms: [],
  graphFactors: [],
  factorsStatus: "",
  chartPeriod: "", //chartLablesMaker("1Y"),
  yLabels: { data: [2, 4, 6, 8], min: 0, max: 10 },
  exportSuccess: false,
};
function buttonsChecker(state) {
  let disabled = {
    factor: true,
    nutrients: true,
    start: true,
    end: true,
    time: true,
    plotBtn: true,
  };

  const symptomFilled =
    state.OptionForm.symptom &&
    state.OptionForm.symptom !== "null" &&
    state.OptionForm.symptom !== "empty";

  const factorFilled =
    state.OptionForm.factor &&
    state.OptionForm.factor !== "null" &&
    state.OptionForm.factor !== "empty";

  const nutrientsFilled =
    state.OptionForm.nutrients &&
    state.OptionForm.nutrients !== "null" &&
    state.OptionForm.nutrients !== "empty";

  const DurationFilled =
    state.OptionForm.end &&
    state.OptionForm.end !== "null" &&
    state.OptionForm.end !== "empty";

  // Enable Category if Symptom is not placeholder or "No history data ..."
  if (symptomFilled) {
    disabled.factor = false;
  }

  // Enable Trigger if a Category selected
  if (factorFilled) {
    disabled.nutrients = false;
  }

  // Enable Date and Duration if Trigger is not placeholder or "No history data ..." 
  if (nutrientsFilled) {
    disabled.start = false;
    disabled.end = false;
  }

  // Enable Plot button all fields are filled (not placeholder or "No history data ...")
  if (
    symptomFilled &&
    factorFilled &&
    nutrientsFilled &&
    state.OptionForm.start &&
    DurationFilled 
  ) {
    disabled.plotBtn = false;
  }

  return disabled;
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case GRAPH_INITIALIZATION:
      let users = [action.users];
      if (action.users.sub_users) users = [...users, ...action.users.sub_users];
      let selectedUser = users[0];
      users = _.orderBy(
        users,
        [(user) => (user.first_name + " " + user.last_name).toLowerCase()],
        ["asc"]
      );

      let rawData = Array.isArray(action.data && action.data.Data)
        ? action.data.Data.find((element) => element.participant === selectedUser._id)
        : null;

      let symptomData = [];

      if (rawData && Array.isArray(rawData.Symptoms)) {
        symptomData = rawData.Symptoms.map((item) => ({
          order: parseInt(item.order),
          label: item.symptom,
          value: item._id,
          unitid: item.unitid,
          visibility: item.visibility,
        }));

        symptomData = _.orderBy(symptomData, ["order"]);
      }

      users = users.map((element) => {
        return {
          label: `${element.first_name} ${element.last_name}`,
          value: element._id,
        };
      });

      let optionForm = {
        ...state.OptionForm,
        user: selectedUser._id,
        symptom: symptomData && symptomData[0] ? symptomData[0].value : "",
      };

      return {
        ...state,
        isLoading: false,
        users: users,
        OptionForm: optionForm,
        selectedUser: selectedUser,
        symptoms: symptomData,
        factors: action.factors,
        symptomOfAllUser: action.data.Data || [],
        disabled: buttonsChecker({
          ...state,
          OptionForm: optionForm,
          symptoms: symptomData,
          nutrients: state.nutrients,
        }),
      };
    // case GRAPH_INITIALIZATION_FAILED:
    //   users = [action.users];
    //   let NewUser = action.baseUser;
    //   if (action.users.sub_users) users = [...users, ...action.users.sub_users];
    //   selectedUser = users[0];
    //   users = users.map((element) => {
    //     return {
    //       label: `${element.first_name} ${element.last_name}`,
    //       value: element._id,
    //     };
    //   });
    //   data = _.orderBy(users, [(user) => user.label.toLowerCase()], ["asc"]);
    //   return { ...state, users, baseUser: NewUser, isLoading: false };
    case getStarted(UPDATE_BIG_GRAPH):
      return {
        ...state,
        isLoading: true,
        searchMode: false,
      };
    case getSucceeded(UPDATE_BIG_GRAPH):
      const newSymptoms = action.payload[0];
      const newFactors = action.payload[1];

      var chartPeriod = chartLablesMaker(
        state.OptionForm.end,
        state.OptionForm.start
      );

      if (newFactors.length === 0) {
        state.factorsStatus = 404;
      } else {
        state.factorsStatus = "";
      }
      // Filter out datapoints with zero as value
      // let removeZeroFactors = newFactors.filter((point) => {
      //   return point.value > 0;
      // });

      // Include datapoints with zero as values, just exclude null and undefined values
      let removeZeroFactors = newFactors.filter(point =>
        point.value !== null && point.value !== undefined
      );

      // >>> NEW: derive symptom unit from the 2nd API (newSymptoms)
      // Strategy: pick the first non-empty 'unit' (or the most frequent, if you prefer)
      let symptomUnit = "";
      if (Array.isArray(newSymptoms) && newSymptoms.length) {
        // Option A: first non-empty
        const firstWithUnit = newSymptoms.find(p => p && p.unit && String(p.unit).trim() !== "");
        symptomUnit = firstWithUnit ? String(firstWithUnit.unit).trim() : "";

        // // Option B: most frequent non-empty (uncomment if you want this instead)
        // const counts = {};
        // for (const p of newSymptoms) {
        //   const u = (p && p.unit ? String(p.unit).trim() : "");
        //   if (u) counts[u] = (counts[u] || 0) + 1;
        // }
        // const top = Object.entries(counts).sort((a,b) => b[1]-a[1])[0];
        // symptomUnit = top ? top[0] : "";
      }
      return {
        ...state,
        graphSymptoms: newSymptoms,
        graphFactors: removeZeroFactors,
        chartPeriod,
        isLoading: false,
        // >>> NEW: write unit to OptionForm so Graph.js axis picks it up
        OptionForm: {
          ...state.OptionForm,
          symptom_unit: symptomUnit,   // ← used by your GraphChart prop
        },
      };
    case getFailed(UPDATE_BIG_GRAPH):
      return {
        ...state,
        isLoading: false,
      };
    case ON_CHANGE_ANALYZEFORM:
      //#region if change user dropdown
      const name = action.event.target
        ? action.event.target.name
        : action.event.name;
      const value = action.event.target
        ? action.event.target.value
        : action.event.value;

      if (name == "user") {
        let factors = action.factors.map((element) => {
          return {
            label: element.label,
            value: element.value,
          };
        });
        let data;
        if (state.symptomOfAllUser && state.symptomOfAllUser.length > 0) {
          data = state.symptomOfAllUser.find((element) => {
            return element.participant == value;
          });
        }

        if (data) {
          data = data.Symptoms.map((element) => {
            return {
              label: element.symptom,
              value: element._id,
              order: element.order,
              unitid: element.unitid,
            };
          });
          data = _.orderBy(data, ["order"]);
        }

        // Get first symptom from Symptom Summary for the selected user
        const firstSymptom = data && data.length > 0 ? data[0].value : "null";

        state.OptionForm = {
          user: value,
          symptom: firstSymptom, // Autofill Symptom dropdown, if saved Symptom data available
          start: state.OptionForm.start,  // preserve date
          end: state.OptionForm.end,  // preserve duration
        };

        state.symptoms = data; // Get list of symptom for the selected user
        state.factors = factors;
        state.disabled = buttonsChecker(state);
      }
      if (name === "symptom") {
        state.OptionForm.factor = "null";
        state.OptionForm.nutrients = "null";
        state.OptionForm.symptom_unit = "";
      }

      if (name == "nutrients") {
        state.nutrients.map((element) => {
          if (element.value == value && element.unit != "") {
            state.OptionForm.trigger_unit = element.unit;  // Get display unit for Graph
          }
        });
        if (value !== "null" && value !== "empty") {
          if (!state.OptionForm.start) {
            state.OptionForm.start = moment().subtract(1, "months"); // Autofill date with a date one month ago from current
          }
          if (!state.OptionForm.end || state.OptionForm.end == "null") {
            state.OptionForm.end = "1M"; // Autofill duration with 1 Month
          }
        }
      }
      //#endregion  if change user dropdown

      state.OptionForm[name] = value;
      if (state.OptionForm.factor == "null") {
        state.OptionForm.nutrients = "null";
        state.nutrients = "";
      }
      if (state.OptionForm.symptom == "null") {
        state.OptionForm.factor = "null";
        state.OptionForm.nutrients = "null";
      }
      return {
        ...state,
        disabled: buttonsChecker(state),
        counterState: state.counterState + 1,
        searchMode: true,
        graphSymptoms: [],
        graphFactors: [],
        chartPeriod: "",
        factorsStatus: "",
        nutrients: state.nutrients,
      };
    case getStarted(ON_CHANGE_FACTOR_ANALYZEFORM):
      state.factorsStatus = "";
      state.OptionForm["factor"] = action.payload[0];
      return {
        ...state,
        isLoading: true,
        graphSymptoms: [],
        graphFactors: [],
        chartPeriod: "",
        searchMode: true,
      };

    case getSucceeded(ON_CHANGE_FACTOR_ANALYZEFORM):
      let nutrients = action.payload.data;
      state.OptionForm["factor"] = action.payload.id;
      nutrients = nutrients.map((element) => {
        return {
          label: `${element.name}`,
          value: element._id,
          unit: element.unit !== undefined ? element.unit : "",
          tg: Number(element.tik || 0),
          tcg: Number(element.tik_cg || 0),
          ti: Number(element.cross || 0),
        };
      });
      state.OptionForm = {
        ...state.OptionForm,
        nutrients: "null",
      };

      return {
        ...state,
        disabled: buttonsChecker(state),
        counterState: state.counterState + 1,
        nutrients: nutrients,
        isLoading: false,
      };
    case getFailed(ON_CHANGE_FACTOR_ANALYZEFORM):
      nutrients = [];
      if (nutrients.length == 0) {
        nutrients = [
          {
            label: i18n.t("graph.NO_TRIGGER_DROPDOWN_TEXT"),
            value: "empty",
            noBadges: true,
          },
        ];
      }
      return {
        ...state,
        disabled: buttonsChecker(state),
        counterState: state.counterState + 1,
        nutrients: nutrients,
        isLoading: false,
      };
    case getEnded(ON_CHANGE_FACTOR_ANALYZEFORM):
      return {
        ...state,
        disabled: buttonsChecker(state),
        counterState: state.counterState + 1,
        isLoading: false,
      };
    case ANALYZEPAGE_DATE_CHANGED:
      state.OptionForm.start = action.val;
      let oldDate = moment(state.OptionForm.oldDate).unix();
      let newDate = moment(state.OptionForm.start).unix();
      if (
        moment(state.OptionForm.oldDate).unix() ===
        moment(state.OptionForm.start).unix()
      ) {
      } else {
        state.searchMode = true;
        state.graphSymptoms = [];
        state.graphFactors = [];
        state.chartPeriod = "";
        state.factorsStatus = "";
      }

      return {
        ...state,
        disabled: buttonsChecker(state),
        counterState: state.counterState + 1,
      };
    case RESET_ANALYZE_PAGE:
      return { ...initialState };
    case getStarted(ON_GRAPH_EXPORT):
      state.pointAlert = false;
      return { ...state, isLoading: true, exportSuccess: false };
    case getSucceeded(ON_GRAPH_EXPORT):
      return { ...state, exportSuccess: true };
    case getFailed(ON_GRAPH_EXPORT):
      if (action.payload && action.payload.message) {
        if (action.payload.message == "your_point_is_insufficient") {
          state.pointAlert = true;
        } else {
          alert(action.payload.message);
        }
      } else {
        alert("Something went wrong!");
      }
      return { ...state };
    case getEnded(ON_GRAPH_EXPORT):
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/graphManagementReducer.js